import { ShoppableHotpoint } from '@floori-web/models';
import { RoomEnvironmentMapDto, VisualizationType } from '@floori-web/visualization-engine';
import { PlaneObject, VectorBasis } from '@floori-web/visualization-models';

export enum VisualizationLightOperation {
    default = 'DEFAULT',
    overlay = 'OVERLAY',
}

export interface EstimationDto {
    hasFullScale: boolean;
    id?: string;
    name?: string;
    visualizationType: VisualizationType;
    roomTexture: string;
    maskTexture: string;
    lightTexture: string;
    model3d: string;
    lightOperation?: VisualizationLightOperation;
    ambientLight?: number;
    vectors?: VectorBasis;
    cotFov2?: number;
    verticalFov?: number;
    operatorAltitude?: number;
    environmentMap?: RoomEnvironmentMapDto;
    visitorRoom?: boolean;
    carpetPosition?: PlaneXYPosition;
    nodes: PlaneObject[];
    shoppableHotpoint: ShoppableHotpoint[];
    rugPosition?: { x: number; y: number };
}

export interface PlaneXYPosition {
    x: number;
    y: number;
}
